import React, { PropsWithChildren, useContext, useMemo } from "react";
import { usePopoverContext } from "@chakra-ui/react";
import { useFilterModalContext } from "../FiltersModal/FiltersModal";

type DocumentsFilterContextValues = {
  onClose: () => void;
};

const DocumentsFilterContext =
  React.createContext<DocumentsFilterContextValues>(
    {} as DocumentsFilterContextValues
  );

export const useDocumentsFilterContext = () =>
  useContext(DocumentsFilterContext);

export const PopoverDocumentsFilterProvider = ({
  children,
}: PropsWithChildren) => {
  const { onClose } = usePopoverContext();
  const value = useMemo(() => ({ onClose }), [onClose]);

  return (
    <DocumentsFilterContext.Provider value={value}>
      {children}
    </DocumentsFilterContext.Provider>
  );
};

export const ModalDocumentsFilterProvider = ({
  children,
}: PropsWithChildren) => {
  const { onClose } = useFilterModalContext();
  const value = useMemo(() => ({ onClose }), [onClose]);

  return (
    <DocumentsFilterContext.Provider value={value}>
      {children}
    </DocumentsFilterContext.Provider>
  );
};
